import { createContext, useContext, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { useSnack } from "./AlertContext";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const setSnack = useSnack();
  const [user, loading, error] = useAuthState(auth);

  if (error) {
    setSnack({
      type: "error",
      message:
        "There was a problem fetching your profile. Please refresh the page.",
      open: true
    });
  }

  if (loading) {
    return <Typography>Initialising User...</Typography>;
  }

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = {
  children: PropTypes.node
};

export const useUser = () => useContext(UserContext);

export const RequireAuth = ({ children }) => {
  const navigate = useNavigate();
  const user = useUser();

  useEffect(() => {
    if (!user) navigate("/login");
  });

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.node
};
